import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';
import setupAddToCart from './add_to_cart';
import setupStraightEnrollment from  './straight_enrollment';
import timezone from 'mex_components/app/scripts/date/timezone';

addStartupScript(() => {
  const startDateEl = document.querySelector('.js-details-duration');

  if (startDateEl) {
    const start = new Date(startDateEl.dataset.start);
    const end = new Date(startDateEl.dataset.end);

    const details = document.querySelector('.js-details-date');

    details.innerText = new Intl.DateTimeFormat('en-us', {
      month: 'long',
      day: 'numeric'
    }).format(start);

    const weekDay = new Intl.DateTimeFormat('en-us', {
      weekday: 'long'
    }).format(start);
    const timeFmt = new Intl.DateTimeFormat('en-us', {
      hour: 'numeric',
      minute: 'numeric'
    });
    const startTime = timeFmt.format(start);
    const endTime = timeFmt.format(end);

    startDateEl.innerText = `${weekDay} @ ${startTime}-${endTime} (${timezone.shorterName()})`;
  }

  setupAddToCart();
  setupStraightEnrollment();
});
